export { default as ActivityDetail } from "./ActivityDetail";

